declare global {
    interface Window {
        dataLayer: unknown[]
        gtag?: (...args: unknown[]) => void
    }
}

const measurementId = import.meta.env.VITE_GA_MEASUREMENT_ID as string | undefined
const GA_ID_PATTERN = /^G-[A-Z0-9]{4,}$/

export function initGA(): void {
    if (!measurementId || !GA_ID_PATTERN.test(measurementId) || window.gtag) return

    window.dataLayer = window.dataLayer || []
    // Must use `arguments` (not rest params) — gtag.js expects Arguments objects in the dataLayer
    window.gtag = function () {
        // eslint-disable-next-line prefer-rest-params
        window.dataLayer.push(arguments)
    }
    window.gtag('js', new Date())
    window.gtag('config', measurementId, {
        send_page_view: false, // We send page views manually on route changes
    })

    const script = document.createElement('script')
    script.async = true
    script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`
    document.head.appendChild(script)
}

export function trackPageView(path: string, title?: string): void {
    if (!measurementId || !window.gtag) return

    window.gtag('event', 'page_view', {
        page_path: path,
        page_title: title ?? document.title,
    })
}
